var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect } from "react";
var loadEmbeddedService = function () { return __awaiter(void 0, void 0, void 0, function () {
    var script;
    return __generator(this, function (_a) {
        if (window.embedded_svc) {
            return [2 /*return*/, window.embedded_svc];
        }
        script = document.createElement("script");
        script.src = "https://service.force.com/embeddedservice/5.0/esw.min.js";
        script.type = "text/javascript";
        document.body.appendChild(script);
        return [2 /*return*/, new Promise(function (resolve, reject) {
                script.onload = function () {
                    if (window.embedded_svc) {
                        resolve(window.embedded_svc);
                    }
                    else {
                        reject("Failed to load Salesforce chat script");
                    }
                };
                script.onerror = function () {
                    reject("Failed to load Salesforce chat script");
                };
            })];
    });
}); };
var initSalesforceChat = function (opts, width, height) { return __awaiter(void 0, void 0, void 0, function () {
    var es;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, loadEmbeddedService()];
            case 1:
                es = _a.sent();
                es.settings.displayHelpButton = false;
                es.settings.widgetWidth = width;
                es.settings.widgetHeight = height;
                es.settings.enabledFeatures = ["LiveAgent"];
                es.settings.entryFeature = "LiveAgent";
                es.settings.language = "en";
                es.settings.defaultMinimizedText = "Chat";
                es.settings.disabledMinimizedText = "No Agents";
                es.settings.offlineSupportMinimizedText = "Offline";
                es.settings.loadingText = ""; //(Defaults to Loading)
                es.settings.extraPrechatInfo = [
                    {
                        entityName: "Contact",
                        saveToTranscript: "Contact",
                        showOnCreate: true,
                        entityFieldMaps: [
                            {
                                doCreate: false,
                                doFind: true,
                                fieldName: "LastName",
                                isExactMatch: true,
                                label: "Last Name",
                            },
                            {
                                doCreate: false,
                                doFind: true,
                                fieldName: "FirstName",
                                isExactMatch: true,
                                label: "First Name",
                            },
                            {
                                doCreate: false,
                                doFind: true,
                                fieldName: "Email",
                                isExactMatch: true,
                                label: "Email",
                            },
                        ],
                    },
                    {
                        entityName: "LiveChatTranscript",
                        showOnCreate: true,
                        linkToEntityName: "Case",
                        linkToEntityField: "Id",
                        saveToTranscript: "TranscriptId",
                        entityFieldMaps: [
                            {
                                isExactMatch: true,
                                fieldName: "Id",
                                doCreate: false,
                                doFind: true,
                                label: "TranscriptRecordId",
                            },
                        ],
                    },
                    {
                        entityName: "Case",
                        showOnCreate: true,
                        linkToEntityName: "LiveChatTranscript",
                        linkToEntityField: "Id",
                        saveToTranscript: "CaseId",
                        entityFieldMaps: [
                            {
                                isExactMatch: true,
                                fieldName: "Id",
                                doCreate: false,
                                doFind: true,
                                label: "CaseRecordId",
                            },
                        ],
                    },
                ];
                es.init(opts.hostname || "https://zeninternet--testing1.sandbox.my.salesforce.com", opts.setupURL ||
                    "https://zeninternet--testing1.sandbox.my.salesforce-sites.com/liveAgentSetupFlow", opts.gslbBaseURL || "https://service.force.com", opts.organizationId || "00D5t0000004fB9", opts.deploymentName || "Live_Chat_Embedded_Service_Deployment", {
                    baseLiveAgentContentURL: opts.baseLiveAgentContentURL ||
                        "https://c.la11-core1.sfdc-cehfhs.salesforceliveagent.com/content",
                    deploymentId: opts.deploymentId || "572690000010wC4",
                    buttonId: opts.buttonId || "573690000010wC9",
                    baseLiveAgentURL: opts.baseLiveAgentURL ||
                        "https://d.la11-core1.sfdc-cehfhs.salesforceliveagent.com/chat",
                    eswLiveAgentDevName: opts.eswLiveAgentDevName || "Live_Chat_Group",
                    isOfflineSupportEnabled: false,
                });
                return [2 /*return*/];
        }
    });
}); };
var InstallLiveagent = function (props) {
    useEffect(function () {
        initSalesforceChat(props.options, props.width, props.height);
    }, []);
    return null;
};
export default InstallLiveagent;
